import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Applies DD-MM-YYYY monkey-patches to Date display methods app-wide.
import "@/lib/dates";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
